import React, { useEffect, useState } from 'react';
import { Truck } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { shippingAPI } from '../lib/api';

// Representative capital postcodes, used when the buyer has no postcode in their profile
const CAPITAL_POSTCODES = {
  FR: '75001', ES: '28001', IT: '00118', DE: '10115', BE: '1000', NL: '1012', PT: '1100-148', LU: '1009',
  AT: '1010', IE: 'D01', PL: '00-001', SE: '11120', DK: '1050', FI: '00100', CZ: '11000', SK: '81101',
  SI: '1000', HR: '10000', HU: '1011', RO: '010011', BG: '1000', GR: '10431', EE: '10111', LV: '1050',
  LT: '01100', CY: '1010', MT: 'VLT1010',
};

export const ShippingEstimate = ({ sellerId, user }) => {
  const { t, i18n } = useTranslation();
  const [state, setState] = useState({ loading: true, price: null });
  const country = (user?.country || 'FR').toUpperCase();
  const postal = user?.postal_code || CAPITAL_POSTCODES[country];

  useEffect(() => {
    if (!sellerId || !postal) { setState({ loading: false, price: null }); return; }
    shippingAPI.getRates({ seller_id: sellerId, to_country: country, to_postal_code: postal, weight: 0.6 })
      .then(res => {
        const prices = (res.data.shipping_options || []).map(o => o.price);
        setState({ loading: false, price: prices.length ? Math.min(...prices) : null });
      })
      .catch(() => setState({ loading: false, price: null }));
  }, [sellerId, country, postal]);

  let countryLabel = country;
  try { countryLabel = new Intl.DisplayNames([i18n.language], { type: 'region' }).of(country) || country; } catch { /* keep code */ }

  return (
    <div className="mt-3 inline-flex items-center gap-2 px-3 py-1.5 rounded-lg bg-[#E8F4FD] text-xs text-[#033871]" data-testid="shipping-estimate">
      <Truck className="w-3.5 h-3.5 text-[#0C63BF]" />
      {state.loading ? t('listing.shipping_estimate_loading')
        : state.price != null
          ? <span>{t('listing.shipping_estimate', { country: countryLabel })} <b data-testid="shipping-estimate-price">{state.price.toLocaleString(i18n.language, { style: 'currency', currency: 'EUR' })}</b></span>
          : t('listing.shipping_estimate_unavailable', { country: countryLabel })}
    </div>
  );
};
